import moment from "moment";
import Initial from "../../helpers/Initial";

const Footer = () => {
  return (
    <footer className="footer-wrap">
      <div className="container">
        &copy; {moment().format("Y")} Backrr. All Rights Reserved. &nbsp;
        <img className="realtime-logo" src={Initial?.branding?.poweredbylogo} alt={process.env.REACT_APP_APPLICATION_NAME} />
      </div>
    </footer>
  );
};

export default Footer;
